export default __webpack_public_path__ + "static/media/nissanka.9a6f61f8.jpg";